/**
 * Styled Components - Created by cazarez on 01/03/18.
 */
import Icon from 'antd/lib/icon'
import Menu from 'antd/lib/menu'
import styled from 'styled-components'
import {
  GRAY_DARK,
  RED_TRANSPARENT,
  WHITE,
  BLUE,
  GRAY_MEDIUM
} from '../../theme/colors'

interface DivProps {
  index?: number
  secondary?: boolean
  cursor?: string
  marginLeft?: string
  marginRight?: string
  color?: string
  fontSize?: string
  order?: number
  designLabView?: boolean
  fromCatalog?: boolean
}

export const Container = styled.div`
  #ThumbnailLoading {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }

  #NoResultsFound {
    display: flex;
    height: 60vh;
    justify-content: center;
  }
`

interface HeadRowProps {
  withoutPadding?: boolean
  fromCatalog?: boolean
}

interface ButtonProps {
  secondary?: boolean
  maxMargin?: boolean
}

export const HeadRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: ${({ withoutPadding }: HeadRowProps) =>
    withoutPadding ? '0' : '0 2% 0 5%;'};

  #TotalItems {
    height: 23px;
    color: #5f6062;
    font-size: 16px;
    line-height: 23px;
  }

  #SortOptions {
    display: flex;
    align-items: center;
  }

  #SortByText {
    color: #5f6062;

    &:hover {
      cursor: pointer;
    }
  }

  #SortArrow {
    margin-left: 5px !important;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 0;
  }
`

export const SortByLabel = styled.div`
  height: 22px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-right: 5px;
`

export const ThumbnailsList = styled.ul`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${({ withoutPadding }: HeadRowProps) =>
    withoutPadding ? 'padding: 0px;' : ''};
  width: 100%;
  padding-left: ${({ designLabView }: DivProps) => (designLabView ? '0px' : 'auto')};

  &[data-appearance='catalog'] {
    gap: var(--spacing-24) var(--catalog-grid-gap-mobile);
    padding: 0;

    @media (min-width: 1024px) {
      gap: 40px var(--catalog-grid-gap-desktop);
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 0;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 0;
    justify-content: space-between;
  }

  @media (min-width: 2024px) {
    justify-content: ${({ designLabView }: DivProps) => (designLabView ? 'flex-start' : 'none')};
  }
`

export const ThumbnailListItem = styled.li`
  list-style: none;
  width: ${({ designLabView, fromCatalog }: DivProps) => {
    if (fromCatalog) {
      return 'calc((100% - var(--catalog-grid-gap-mobile)) / 2)'
    }
    return designLabView ? 'fit-content' : 'calc(95% / 2)'
  }};
  order: ${({ order }: DivProps) => order || 'unset'};
  animation: scale-in-center 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 
    ${({ index }: DivProps) => `${index ? (index * 0.1) : '1'}s`} both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  ${({ fromCatalog }: DivProps) => fromCatalog ? `
    @media (min-width: 1024px) {
      width: calc((100% - (3 * var(--catalog-grid-gap-desktop))) / 4);
      padding-bottom: 0;
    }
  ` : ''}

  @media (min-width: 481px) {
    justify-content: center;
    width: ${({ fromCatalog }: DivProps) =>
      fromCatalog ? 'calc((100% - var(--catalog-grid-gap-mobile)) / 2)' : '50%'};
  }

  @media (min-width: 698px) {
    width: ${({ fromCatalog }: DivProps) =>
      fromCatalog ? 'calc((100% - var(--catalog-grid-gap-mobile)) / 2)' : 'calc(100% / 3)'};
  }

  @media (min-width: 769px) {
    width: ${({ fromCatalog }: DivProps) =>
      fromCatalog ? 'calc((100% - var(--catalog-grid-gap-mobile)) / 2)' : '50%'};
  }

  @media (min-width: 990px) {
    padding-bottom: ${({ fromCatalog }: DivProps) => (fromCatalog ? '0' : '20px')};
    width: ${({ fromCatalog }: DivProps) =>
      fromCatalog ? 'calc((100% - var(--catalog-grid-gap-mobile)) / 3)' : '33%'};
  }

  @media (min-width: 1260px) {
    width: ${({ fromCatalog }: DivProps) =>
      fromCatalog
        ? 'calc((100% - (3 * var(--catalog-grid-gap-desktop))) / 4)'
        : '25%'};
  }

  @media (min-width: 2024px) {
    width: ${({ fromCatalog }: DivProps) =>
      fromCatalog
        ? 'calc((100% - (3 * var(--catalog-grid-gap-desktop))) / 4)'
        : '15%'};
  }
  ${({ designLabView }: DivProps) => designLabView ? `
    justify-content: center;
    display: flex;
    margin-right: 10px;
    width: 100% !important;
    &:last-child {
      margin-right: 0px;
    }
    @media (min-width: 481px) {
      justify-content: center;
      max-width: 206px;
    }
    @media (min-width: 698px) {
      max-width: 206px;
    }
    @media (min-width: 769px) {
      max-width: 206px;
    }
    @media (min-width: 990px) {
      padding-bottom: 20px;
      max-width: 150px;
    }
    @media (min-width: 1260px) {
      max-width: 176px;
    }
    @media (min-width: 1440px) {
      max-width: 176px;
      margin-right: 30px;
    }
    @media (min-width: 1768px) {
      max-width: 160px;
      margin-right: 20px;
    }
    @media (min-width: 2024px) {
      margin-right: 24px;
      max-width: 214px;
    }
  ` : ''}
`

export const PaginationRow = styled.div`
  text-align: right;
  padding-right: 2%;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 0;
    text-align: center;
  }
`

export const MenuStyle = {
  width: '200px'
}

export const CatalogEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: var(--spacing-128) var(--spacing-16) var(--spacing-48);
  text-align: center;

  #CatalogEmptyTitle {
    margin: 0 0 var(--spacing-12);
    font: 600 22px/26px var(--font-barlow-semi-condensed);
    letter-spacing: 0.44px;
    color: var(--neutral-darkest);
  }

  #CatalogEmptyDescription {
    margin: 0 0 var(--spacing-24);
    font: 400 16px/24px var(--font-inter);
    color: var(--neutral-body);
  }

  .catalog-empty-button {
    height: 42px;
    padding: var(--spacing-8) var(--spacing-16);
    border: var(--border-regular) solid var(--neutral-muted);
    border-radius: 0;
    background: var(--neutral-white);
    cursor: pointer;
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1.12px;
    text-transform: uppercase;
    color: var(--neutral-body);

    &:hover,
    &:focus {
      border-color: var(--neutral-darkest);
      outline: none;
    }
  }
`

export const CatalogPaginationRow = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--spacing-42) 0;

  .ant-pagination-item,
  .ant-pagination-item-link {
    border: unset;
  }

  .ant-pagination-item-active {
    border: 1px solid var(--neutral-border-med);
    a {
      color: var(--neutral-darkest);
      font-weight: 600;
    }
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  max-width: 148px;
  width: 100%;
`

export const ButtonContainer = styled.div`
  user-select: none;
  display: flex !important;
  align-items: center;
  margin: ${({ maxMargin }: ButtonProps) => (maxMargin ? '8px 0' : '4px 0')};
  width: 100%;
`

export const ActionButton = styled.div`
  user-select: none;
  background-color: ${({ secondary }: ButtonProps) =>
    secondary ? RED_TRANSPARENT : '#fffffff0'};
  color: ${({ secondary }: ButtonProps) => (secondary ? WHITE : GRAY_DARK)};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
  }
`

export const ActionButtonMiddle = styled.div`
  user-select: none;
  background-color: ${({ secondary }: ButtonProps) =>
    secondary ? '#f6d35fe6' : '#79b968d9'};
  color: ${({ secondary }: ButtonProps) => (!secondary ? WHITE : GRAY_DARK)};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
  }
`

export const CopyButton = styled.div`
  user-select: none;
  background-color: #000000a3;
  color: ${WHITE};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: #000000e3;
  }
`

export const AddNewDesign = styled.div`
  border: 1px dashed ${BLUE};
  height: 221px;
  margin-top: 4px;
  margin-right: 41px;
  max-width: 204px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  border-radius: 3px;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #f2f8ff;
  }
  animation: scale-in-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.75);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  ${({ secondary }: DivProps) => secondary ? `
    margin: 0 auto;
    margin-top: -78px;
  ` : `
    @media (max-width: 768px) {
      margin-right: 30px;
    }
    @media (max-width: 720px) {
      margin-right: 20px;
    }
    @media (max-width: 440px) {
      height: 202px;
      max-width: 198px;
    }
    @media (max-width: 440px) {
      max-width: 174px;
    }
    @media (max-width: 386px) {
      max-width: 164px;
    }
    @media (max-width: 368px) {
      max-width: 154px;
    }
  `}
  #PlusSign {
    font-weight: bold;
    margin-bottom: 17px;
    font-size: 18px;
  }

  #NewLabel {
    font-size: 16px;
  }
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const WarningIcon = styled(Icon)``

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
  `

export const StyledMenu = styled(Menu)`
  box-shadow: 0 2px 8px #00000063;
  font-family: Avenir;
  width: 250px;

  #MenuHeader {
    display: flex;
    flex-direction: column;
    margin: 4px 0;
  }

  #MenuHeaderTitle {
    font-weight: 600;
    font-size: 17px;
    margin: 0;
  }

  #MenuHeaderText {
    font-size: 12px;
    margin-bottom: 6px;
    white-space: break-spaces;
  }

  #ThreeDIcon {
    transition: all .25s;
    max-width: 18px;
    margin-right: 8px;
  }

  #MenuItemCurrencyContainer {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .ant-dropdown-menu-item .anticon:first-child {
    margin-right: 10px;
  }

  .ant-dropdown-menu-submenu-title > .anticon:first-child {
    margin-right: 10px;
  }

  .ant-dropdown-menu-item {
    line-height: 25px;
    font-size: 14.5px;
    border-top: 1px solid #f3f3f3;   
    &:first-child {
      border-top: none;
    }
  }
`

export const StyledIcon = styled(Icon)`
  cursor: ${({ cursor }: DivProps) => (cursor ? cursor : 'unset')};
  margin-left: ${({ marginLeft }: DivProps) => (marginLeft ? marginLeft : '0')};
  color: ${({ color }: DivProps) => (color ? color : 'unset')};
`

export const MenuItem = styled(Menu.Item)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: default; 
  font-size: ${({ fontSize }: DivProps) => fontSize === 'small' ? '12px' : 'unset' };
  &:hover {
    background: none;
  }
`

export const MenuItemText = styled.p`
  font-size: 12px;
  white-space: break-spaces;
  transition: color 0.2s ease-in-out;
  text-align: right;
  margin-bottom: 0;
`

export const MenuItemCurrency = styled.span`
  background-color: #7ec1b6;
  color: #FFFFFF;
  margin: 2px 2px;
  padding: 1px 4px;
  border-radius: 8px;
`

export const MenuHeaderImportedLabel = styled.p`
  font-size: 12px;
  margin: 0;
  color: ${GRAY_MEDIUM};
  white-space: break-spaces;
  line-height: initial;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductCatalogueThumbnailsListV2/styledComponents.tsx